import Job from '@/models/Job'
import Api from '@/services/api'
import { each, find } from 'lodash'

export default {
  namespaced: true,
  state: {
    list: [],
    listMeta: {},
    jobDetails: null
  },

  mutations: {
    setJobList(state, jobs) {
      each(jobs, job => {
        const exist = find(state.list, { id: job.id })
        if (!exist) {
          state.list.push(new Job(job))
        }
      })
    },

    setJobListMeta(state, meta) {
      state.listMeta = meta
    },

    clearJobList(state) {
      state.list = []
      state.listMeta = {}
    },

    setJobDetails(state, job) {
      if (job instanceof Job) {
        state.jobDetails = job
      } else {
        state.jobDetails = new Job(job)
      }
    },

    clearJobDetails(state) {
      state.jobDetails = null
    }
  },

  actions: {
    async getJobs({ commit }, params) {
      const query = Job.page(params.page || 1).include('user')

      /* Check if for only a specific user */
      if (params.user) {
        query.custom(`users/${params.user}/tools`)
      } else {
        query.custom('tools')
      }

      if (params.search) {
        query.where('search', params.search)
      }

      const res = await query.params({ limit: 20 }).get()

      commit('setJobList', res.data)
      commit('setJobListMeta', res.meta)
    },

    async getJobDetails({ commit, rootState }, params) {
      const { data } = await Api.get(
        params.user
          ? `users/${params.user}/tools/${params.id}`
          : `tools/${params.id}`
      )
      commit('setJobDetails', data.data)
    }
  }
}
